import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Contract } from "../../../classes/contract";
import { ContractService } from "../../../services/contract";
import { ChecklistService } from "../../../services/checklist";
import { Router } from '@angular/router';
import { switchMap } from "rxjs/operators";
import { from } from "rxjs";
import {Checklist} from "../../../classes/checklist";
import {ContractFounder} from "../../../classes/contractFounder";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ContractFounderCreateModalComponent} from "../../../modals/contract/contract-founder-create-modal.component";
import {ContractFounderService} from "../../../services/contractFounder";

@Component({
  selector: 'app-contract-create',
  templateUrl: './contract-create.component.html',
  styleUrls: ['./contract-create.component.css']
})
export class ContractCreateComponent implements OnInit {

  contract = new Contract();
  contractCreationResult = true;

  checklists: Array<Checklist> = [];
  contractFounders: Array<ContractFounder> = [];

  constructor(private router: Router,
              private modalService: NgbModal,
              private contractService: ContractService,
              private contractFounderService: ContractFounderService,
              private checklistService: ChecklistService) { }

  ngOnInit(): void {
      this.checklistService.getAll()
          .pipe(
              switchMap((checklistsData: any) => from(checklistsData))
          )
          .subscribe({
              next: (checklist: any) => {
                  this.checklists.push(checklist);
              },
              error: e => {
                  console.log('Error: ' + e);
              }
          });

      this.contractFounderService.getAll()
          .pipe(
              switchMap((contractFoundersData: any) => from(contractFoundersData))
          )
          .subscribe({
              next: (contractFounder: any) => {
                  this.contractFounders.push(contractFounder);
              },
              error: e => {
                  console.log('Error: ' + e);
              }
          });
  }

  openContractFounderCreateModal() {
      const modalRef = this.modalService.open(ContractFounderCreateModalComponent);
      modalRef.result.then((contract: Contract) => {
          if (contract.name) {
              this.contractFounderService.create(contract)
                  .subscribe({
                      next: (contractCreated: any) => {
                          this.contractFounders.push(contractCreated);
                      },
                      error: (err: HttpErrorResponse) => {
                          console.log(err);
                      }
                  });
          }
      });
  }

  onSubmit() {
    this.contractService.create(this.contract)
      .subscribe({
        next: () => {
          this.router.navigate(['/contract']);
        },
        error: (err: HttpErrorResponse) => {
          this.contractCreationResult = false;
          console.log(err);
        }
      });
  }

}
